import { FlowStepId, FlowActionId } from '../woz-flow.types';
import type { FlowStepDefinition } from '../woz-flow.types';

/**
 * Ask the user if they have additional complaints to add.
 * Shown after all questions for all current complaints have been answered.
 */
export const askMoreComplaintsStep: FlowStepDefinition = {
  id: FlowStepId.AskMoreComplaints,
  type: 'action',
  text: 'Heb je nog andere bezwaren die je wilt toevoegen?',
  actions: [
    {
      id: FlowActionId.MoreComplaintsYes,
      label: 'Ja, ik heb nog meer bezwaren',
      event: 'trigger',
      payload: FlowStepId.AskMoreComplaints,
    },
    {
      id: FlowActionId.MoreComplaintsNo,
      label: 'Nee, dit was alles',
      event: 'trigger',
      payload: FlowStepId.AskMoreComplaints,
      primaryButton: true,
    },
  ],
  disableInput: true,
  waitForTrigger: FlowStepId.AskMoreComplaints,
};

/**
 * Final message shown when the user is done adding complaints.
 */
export const flowCompleteStep: FlowStepDefinition = {
  id: FlowStepId.FlowComplete,
  type: 'message',
  text: 'Bedankt! Ik heb alle informatie verzameld. We gaan nu naar het overzicht.',
};
